import React from 'react';
import PropTypes from 'prop-types';
import {Tooltip, OverlayTrigger} from 'react-bootstrap';

import './StatusIcons.scss';

export default class StatusIcons extends React.Component {
	static OK = 'fa-check-circle';
	static WARN = 'fa-exclamation-triangle';
	static ERROR = 'fa-times-circle';
	static INFO = 'fa-info-circle';
	static HELP = 'fa-question-circle-o';

	static propTypes = {
		reactTooltip: PropTypes.bool,
        title: PropTypes.any,
		type: PropTypes.string.isRequired
	};

	render() {
		if (this.props.reactTooltip) {
			const tooltip = (
				<Tooltip id="tooltip">
					{this.props.title}
				</Tooltip>
			);

			return (
				<OverlayTrigger delay={200} overlay={tooltip} placement="bottom">
					<span className="statusIcons">
						<i aria-hidden="true" className={"fa " + this.props.type}></i>
					</span>
				</OverlayTrigger>
			);
		}

		return (
			<span className="statusIcons" title={this.props.title}>
				<i aria-hidden="true" className={"fa " + this.props.type}></i>
			</span>
		);
	}
}
